import { useIntl } from 'react-intl';
import { SectionHeading } from '@ets/design-system';

import { useDispatch } from '_common/hooks';
import { openModal } from '_common/modals/ModalsSlice';

const ElementHeading = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const openElementStatusModal = () => {
    dispatch(openModal('ElementStatusFormModal'));
  };

  return (
    <SectionHeading
      size="l"
      sticky
      title={intl.formatMessage({ id: 'ELEMENT_STATUS' })}
      firstAction={{
        variant: 'primary',
        onClick: openElementStatusModal,
        children: intl.formatMessage({ id: 'NEW_ELEMENT_STATUS' }),
      }}
      testId="element-status"
    />
  );
};

export default ElementHeading;
